import RedirectUrlLink from '../../../../../shared/redirect-url-link/Redirect-Url-Link';

export const CtaView = ({ spaCta }) => {
  return (
    <div className='row pt-4 mx-4'>
      {spaCta[0]?.status === 'Active' ? (
        <div>
          <div>
            <div className='details-label'>CTA</div>
            <div>{spaCta[0]?.status}</div>
          </div>

          <div className='pt-4'>
            <div className='details-label'>CTA Title</div>
            <div>{spaCta[1]?.ctaTitle}</div>
          </div>

          <div className='pt-4'>
            <div className='details-label'>Redirect option</div>
            <div>{spaCta[2]?.redirectOption}</div>
          </div>

          {spaCta[2]?.redirectOption === 'External URL' && (
            <div className='pt-4'>
              <div className='details-label'>Redirect URL</div>
              <div>
                <RedirectUrlLink url={spaCta[3]?.redirectUrl} />
              </div>
            </div>
          )}
        </div>
      ) : (
        <div>
          <div className='details-label'>CTA</div>
          <div>{spaCta[0]?.status}</div>
        </div>
      )}
    </div>
  );
};
